import { exportToCSV } from "./exportUtils.js";
import { getSelectedAddresses } from "./mapUtils.js";


const exportBtn = document.querySelector(".export-button");

if (!exportBtn) {
  console.error("Export button not found.");
} else {
  exportBtn.addEventListener("click", () => {

    const selected = getSelectedAddresses();

    if (!selected || !selected.length) {
      alert("No features selected on the map.");
      return;
    }

    exportToCSV(selected, "selected-addresses.csv");
  });
}